module.exports = __webpack_public_path__ + "static/sec5-bg-sm-fe0ea4723bc3c5d1bcf4ad35bdda8013.jpg";